module.exports = __webpack_public_path__ + "img/monitoring.5c31efca.svg";